import http from "services/http";

import { IMenu, MenuCodeRequest } from "./types";

export const apiGetMenus = (code: MenuCodeRequest) =>
	http.get<BaseAPIResponse<Array<IMenu>>>(`/menus/${code}`);
